import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
import focus from '@alpinejs/focus'
import 'lazysizes'
import AOS from 'aos'

// Import components
import './includes/navigation.js'
import './includes/socialShare.js'
import './alpine/accordion.js'
import './alpine/edit.js'
import './alpine/modal.js'
import './alpine/countdown.js'

// Initialise alpine plugins
window.Alpine = Alpine
Alpine.plugin(collapse)
Alpine.plugin(focus)

// Initialise alpine
Alpine.start()

// Initialise
AOS.init({
    duration: 800,
    offset: 180,
})
